import { IPropsNFButton } from './model';

export { default } from './NFButton';

export interface IPropsNFButtonData extends IPropsNFButton {}
